<script>
  import Button from './Button.svelte';

  export let title = '';
  export let subtitle = '';
  export let price = '';
  export let features = [];
  export let popular = false;
  export let action = { label: '', href: '#' };

  $: className = `pricing-card${popular ? ' popular' : ''}`;
</script>

<article class={className}>
  {#if popular}
    <span class="popular-badge">Популярный</span>
  {/if}

  <div class="pricing-top">
    <h3>{title}</h3>
    <p class="pricing-subtitle">{subtitle}</p>

    <ul>
      {#each features as feature}
        <li>
          <span class="feature-icon" aria-hidden="true"></span>
          <span>{feature}</span>
        </li>
      {/each}
    </ul>
  </div>

  <div class="pricing-bottom">
    <div class="pricing-divider" aria-hidden="true"></div>
    <p class="pricing-price">{price}</p>
    <Button href={action.href} label={action.label} target={action.target} rel={action.rel} variant="primary" />
  </div>
</article>

<style>
  .pricing-card {
    position: relative;
    display: flex;
    min-width: 0;
    flex-direction: column;
    justify-content: space-between;
    gap: 28px;
    padding: 32px 24px 32px;
    border: 2px solid rgba(221, 228, 236, 0.15);
    border-radius: 24px;
    background: #1a1c1d;
    color: #ffffff;
    box-sizing: border-box;
  }

  .popular {
    border-color: #e7b962;
    overflow: visible;
  }

  .popular-badge {
    position: absolute;
    top: -20px;
    left: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 160px;
    padding: 8px 20px;
    border-radius: 60px;
    background: radial-gradient(circle at center, #fbec9d 0%, #edcd75 36%, #dfae4d 72%);
    color: #000000;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.15;
    text-align: center;
    text-transform: uppercase;
    transform: translateX(-50%);
    box-sizing: border-box;
  }

  .pricing-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  h3,
  p,
  ul {
    margin: 0;
  }

  h3 {
    color: #ffffff;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.18;
    text-align: center;
    text-transform: uppercase;
  }

  .pricing-subtitle {
    color: #e7b962;
    font-size: 17px;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
  }

  ul {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 14px;
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.25;
  }

  .feature-icon {
    position: relative;
    flex: 0 0 auto;
    width: 26px;
    height: 26px;
    border: 2px solid #e7b962;
    border-radius: 50%;
    box-sizing: border-box;
  }

  .feature-icon::after {
    position: absolute;
    left: 7px;
    top: 6px;
    width: 8px;
    height: 4px;
    border-left: 2px solid #e7b962;
    border-bottom: 2px solid #e7b962;
    content: '';
    transform: rotate(-45deg);
  }

  .pricing-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .pricing-divider {
    width: 100%;
    height: 1px;
    background: rgba(221, 228, 236, 0.15);
  }

  .pricing-price {
    color: #e7b962;
    font-size: 36px;
    font-weight: 700;
    line-height: 1.16;
    text-align: center;
    white-space: nowrap;
  }

  @media (max-width: 1279px) {
    .pricing-card {
      width: 100%;
      padding: 28px 24px;
    }

    .pricing-price {
      font-size: 40px;
    }
  }

  @media (max-width: 767px) {
    .pricing-card {
      width: 100%;
      gap: 20px;
      padding: 24px 20px;
    }

    .popular-badge {
      min-width: 140px;
      padding: 6px 16px;
      font-size: 14px;
    }

    .pricing-top {
      gap: 18px;
    }

    h3 {
      font-size: 28px;
    }

    .pricing-subtitle {
      font-size: 15px;
    }

    ul {
      gap: 12px;
    }

    li {
      gap: 12px;
      font-size: 15px;
    }

    .feature-icon {
      width: 20px;
      height: 20px;
    }

    .feature-icon::after {
      left: 5px;
      top: 4px;
      width: 6px;
      height: 3px;
    }

    .pricing-bottom {
      gap: 16px;
      width: 100%;
    }

    .pricing-price {
      font-size: 32px;
    }

    .pricing-bottom :global(.button) {
      width: 100%;
    }
  }
</style>
